import { render, staticRenderFns } from "./DetailView.vue?vue&type=template&id=08e8e69c&scoped=true"
import script from "./DetailView.vue?vue&type=script&lang=js"
export * from "./DetailView.vue?vue&type=script&lang=js"
import style0 from "./DetailView.vue?vue&type=style&index=0&id=08e8e69c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e8e69c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08e8e69c')) {
      api.createRecord('08e8e69c', component.options)
    } else {
      api.reload('08e8e69c', component.options)
    }
    module.hot.accept("./DetailView.vue?vue&type=template&id=08e8e69c&scoped=true", function () {
      api.rerender('08e8e69c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GaGaCommunity/CommunityDynamics/DetailView.vue"
export default component.exports